declare const AppVersion: string; // injected from webpack

const requestAccessPath = 'ccRequestAccess';
const hostnameForDev = 'cc-dev.aws.powercommandcloud.com';
const hostnameForQa = 'arrow-qa.aws.powercommandcloud.com';
const hostnameForProd = 'connectcloud.cummins.com';

const config = {
  paths: {
    root: '/',
    login: '/cclogin',
    registration: '/ccUserRegistration',
    logout: '/logout',
    userTraining: 'https://cummins.hubs.vidyard.com/watch/YyHPD7Gvd8nrd6EtfDjqVw',
    noAccessError: '/no-access',
    pccUrl: window.location.hostname.search('cc-dev') > -1
      ? `https://${hostnameForDev}/`
      : window.location.hostname.search('arrow-qa') > -1
        ? `https://${hostnameForQa}/`
        : `https://${hostnameForProd}/`,
    requestAccess: window.location.hostname.search('cc-dev') > -1
      // ? `https://pcc-auth-development.auth.us-east-1.amazoncognito.com/logout?client_id=1j6ajc1041tevdga09t5bke2ev&logout_uri=https://${hostnameForDev}/${requestAccessPath}`
      ? `https://pcc-auth-development.auth.us-east-1.amazoncognito.com/logout?client_id=1j6ajc1041tevdga09t5bke2ev&logout_uri=https://cumminscss--iamosmdev.sandbox.my.site.com/cla/IAM_Authorize?appid=a1aDd0000008yM0IAI`
      : window.location.hostname.search('arrow-qa') > -1
        ? `https://da-pcc-auth-qa.auth.us-east-1.amazoncognito.com/logout?client_id=44bpu5iblr581rk0b7dmnkho41&logout_uri=https://cumminscss--uat25.sandbox.my.site.com/clw/IAM_Authorize?appid=a1aKY000000KXpn`
        : `https://da-pcc-auth-production.auth.us-east-1.amazoncognito.com/logout?client_id=6ru2ep2nnfbhhesvefsqdp9e9k&logout_uri=https://mylogin.cummins.com/clw/IAM_Authorize?appid=a1aKY000000KXpn`,
  },
  reCaptchaKey: '6LcpyCUUAAAAAINYO9CpyvWyJui7U__hK80H8Xpd',
  doorbellEnabled: true,
  gtmId: 'GTM-5NCMCC8',
  appVersion: AppVersion,
};

export default config;
